var map = {
	"./symbol_0.png": 11300,
	"./symbol_1.png": 65197,
	"./symbol_10.png": 97881,
	"./symbol_11.png": 976,
	"./symbol_12.png": 70827,
	"./symbol_2.png": 34870,
	"./symbol_3.png": 48159,
	"./symbol_4.png": 96832,
	"./symbol_5.png": 74953,
	"./symbol_6.png": 60338,
	"./symbol_7.png": 75163,
	"./symbol_8.png": 78924,
	"./symbol_9.png": 31189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17695;